import { cn } from "@omni/utils/styles";

type PriceLineComponentProps = {
    title: string;
    price: string;
    border?: boolean;
    large?: boolean;
};

const PriceLineComponent = ({
    title,
    price,
    border,
    large
}: PriceLineComponentProps) => (
    <ul
        className={cn("tw:flex tw:justify-between tw:px-2", {
            "tw:border-t-3 tw:border-grey-light tw:pt-2 tw:mt-2": border,
            "tw:font-bold tw:text-2xl": large
        })}
    >
        <li>{title}</li>
        <li>{price}</li>
    </ul>
);

export { PriceLineComponent };
